import React from "react";
import GithubIcon from "../../assets/images/icon/GitHub.svg";
import MailIcon from "../../assets/images/icon/Message_duotone_line.png";
import Linkedin from "../../assets/images/icon/linkedin-icon.png";

const Cover = () => {
    return (
        <div className="lg:w-11/12 xl:w-10/12 lg:text-left w-full text-center py-24" id="cover">
            <p className="text-6xl text-secondarylight font-bold leading-tight text-shadow">
                I'm Ashraf, a software engineer <br className="hidden 2xl:block" /> and a frontend developer.
            </p>
            <div className="my-24">
                <p className="text-2xl text-light font-normal leading-normal">
                    I am an expert javaScript developer, specializing in web applications using the React framework.{" "}
                    <br className="hidden 3xl:block" /> I share my stories and achiements in{" "}
                    <a href="https://www.linkedin.com/in/ashraf-raneem-2b94361a0/" target="_blank" rel="noreferrer">
                        <span className="underline underline-offset-8 text-pink">LinkedIn</span>{" "}
                    </a>{" "}
                    , push commits to{" "}
                    <a href="https://github.com/Ashraf-Raneem" target="_blank" rel="noreferrer">
                        <span className="underline underline-offset-8 text-light">Github</span>
                    </a>{" "}
                    , socialize through{" "}
                    <a href="https://www.facebook.com/ashraf.raneem" target="_blank" rel="noreferrer">
                        <span className="underline underline-offset-8 text-blue py-1">Facebook</span>{" "}
                    </a>{" "}
                    <br className="hidden 3xl:block" />
                    and sell clothes on{" "}
                    <a href="https://www.etsy.com/shop/TheEthosAttire" target="_blank" rel="noreferrer">
                        <span className="underline underline-offset-8 text-red py-1">Etsy</span>
                    </a>
                    .
                </p>
            </div>
            <div>
                <ul className="text-light">
                    <li className="flex mb-3">
                        <img style={{ height: "25px", width: "25px" }} src={MailIcon} alt="icon"></img>{" "}
                        <span className="ml-2">ashrafraneem@gmail.com</span>
                    </li>
                    <li className="flex mb-3">
                        <img className="brand-icon" src={GithubIcon} alt="icon"></img>{" "}
                        <span className="ml-2">github.com/Ashraf-raneem</span>
                    </li>
                    <li className="flex">
                        <img className="brand-icon" src={Linkedin} alt="icon"></img>{" "}
                        <span className="ml-2">linkedin.com/in/ashraf-raneem-2b94361a0</span>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default Cover;
